import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { IntegrityMonitorCustomRuleActionsFormController } from '../controller/IntegrityMonitorCustomRuleActionsFormController';
import { IntegrityMonitorCustomRulesAttribute } from '../../../../common/utils/types';
import { Observable } from 'rxjs';
import { Rights } from '@nirvana/shared/constants';

export class IntegrityMonitorCustomRuleActionsFormWebComponent extends BaseWebComponentElement {
  public controller!: IntegrityMonitorCustomRuleActionsFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorCustomRuleActionsFormController,
    });
  }

  public set options(opts: IntegrityMonitorCustomRulesAttribute[]) {
    this.controller.setOptions(opts);
  }

  public refreshOptions(os: string) {
    this.controller.refreshOptions(os);
  }

  public get value() {
    return this.controller.view.formGroup.value;
  }

  public get valid(): boolean {
    return this.controller.selectedCheckboxes.some(x => x);
  }

  public get valid$(): Observable<boolean> {
    return this.controller.valid$;
  }

  public setData(ruleData: any): void {
    this.controller.view.formGroup.value = ruleData;
    if (!Application.Main.hasAllRights([Rights.MANAGE_POLICIES_WRITE])) {
      this.controller.view.formGroup.setDisabled(true);
    }
  }
}
